/* eslint-disable no-use-before-define */
import { css } from '@emotion/core'
import { mediaQueries } from '../twd'

export const listCss = css `
    div {
        display: grid;
        grid-template-columns: 1fr 1fr;
    }
    dt, dd {
        padding: 6px;
        line-height: 1.4;
        font-weight:400;
        color: #242424;
        border-bottom: 1px solid #e4e4e4;
    }
    dt {
        text-align: left;
    }
    dd {
        text-align: right;
        font-weight: 500;
    }
`

export const resultListCss = css `
    & {
        display:grid;
        grid-template-columns: 1fr 1fr;
    }
    dt, dd {
        padding: 6px;
        line-height: 1.4;
        font-weight: 400;
        border-bottom: 1px solid #e4e4e4;
    }
    dt {
        text-align: left;
        color: #242424;
        /* color: #767676; */
    }
    dd {
        text-align: right;
        font-weight: 500;
        color: #242424;
    }
`

export const textAlignRight = css`
    ${mediaQueries.notXs} { text-align: right }
`